import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

export interface datosFact {
  razonSocial: string;
  nif: string;
  direccion: string;
  cp: string;
  pais: string;
  email: string;
  tlf: string;
}

@Component({
  selector: 'datos-facturacion-estudiante',
  templateUrl: './datos-facturacion-estudiante.component.html',
  styleUrls: ['./datos-facturacion-estudiante.component.css']
})

export class DatosFacturacionEstudianteComponent implements OnInit {

  datosFact: datosFact = {
    razonSocial: '',
    nif: '',
    direccion: '',
    cp: '',
    pais: '',
    email: '',
    tlf: '',
  }

  usuario: any;
  token: string;
  loaded: number = 0;

  constructor(
    private afs: AngularFirestore,
  ) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token'));
    this.usuario = JSON.parse(localStorage.getItem('user'));
    this.cargarDatosFact()

  }

  cargarDatosFact() {
    this.afs.collection('usuariosDatosFacturacion').doc(this.usuario.uid).ref.get().then(doc => {
      const datos = doc.data();
      this.datosFact = {
        razonSocial: datos['razonSocial'], //
        nif: datos['nif'],
        direccion: datos['direccion'],
        cp: datos['cp'],
        pais: datos['pais'],
        email: datos['email'],
        tlf: datos['tlf'],
      }
      this.loaded = 1;
      console.log(this.datosFact)
    }).catch(error => {
      console.log(error)
      alert('No se ha cargar los datos de facturacion')
    });
  }

  guardarDatosFact() {
    this.afs.collection('usuariosDatosFacturacion').doc(this.usuario.uid).set(this.datosFact, { merge: true }).then(() => {
      window.location.reload();
    }).catch(error => {
      console.log(error)
    })
  }


}
